import type { ShapeElement } from '@fotoboek/domain';
import { Label, Input } from '../../ui/Input';
import { t } from '../../../i18n';

export function ShapeProperties({
  element,
  onChange,
}: {
  element: ShapeElement;
  onChange: (patch: Partial<ShapeElement>) => void;
}) {
  return (
    <div className="properties-section">
      <div className="left-panel-section-title">{t('editor.properties.shape.heading')}</div>
      {element.shape !== 'line' ? (
        <div className="field-group">
          <Label>{t('editor.properties.shape.fill')}</Label>
          <input
            type="color"
            value={element.fill ?? '#e8e4de'}
            onChange={(e) => onChange({ fill: e.target.value })}
          />
        </div>
      ) : null}
      <div className="field-group">
        <Label>{t('editor.properties.shape.stroke')}</Label>
        <input
          type="color"
          value={element.stroke ?? '#1a1a1a'}
          onChange={(e) => onChange({ stroke: e.target.value })}
        />
      </div>
      <div className="field-group">
        <Label>{t('editor.properties.shape.strokeWidth')}</Label>
        <Input
          type="number"
          min={0}
          step={0.1}
          value={element.strokeWidthMm}
          onChange={(e) => onChange({ strokeWidthMm: Math.max(0, Number(e.target.value)) })}
        />
      </div>
      {element.shape === 'rectangle' ? (
        <div className="field-group">
          <Label>{t('editor.properties.shape.cornerRadius')}</Label>
          <Input
            type="number"
            min={0}
            value={element.cornerRadiusMm}
            onChange={(e) => onChange({ cornerRadiusMm: Math.max(0, Number(e.target.value)) })}
          />
        </div>
      ) : null}
    </div>
  );
}
